export function Footer() {
  return (
    <footer className="footer">
      TURAL DATALINK <span className="slash">//</span> COOLDOWN PLANNER
    </footer>
  );
}
